<template>
	<div class="szzy1">
		<div class="datalist">
			<div class="jktitle">
				<el-skeleton :loading="loading" animated :count="1">
					<template slot="template">
						<el-skeleton-item variant="text" style="height: 35px;" />
					</template>
					<template>
						{{jkTitle}}
					</template>
				</el-skeleton>
			</div>
			<div class="content">
				<div class="content_play">
					<div class="left_video">
						<video :src="playUrl" autoplay="autoplay" loop="loop" controls="controls" controlslist="nodownload" disablePictureInPicture></video>
					</div>
					<div class="teacher">
						<div class="teacher_bar">
							<span :class="{selectBar:selectBar == 1}" @click="selectBar = 1">主讲教师</span>
							<span :class="{selectBar:selectBar == 2}" @click="selectBar = 2">视频列表</span>
						</div>
						<div class="teacher_pic" v-if="selectBar == 1">
							<el-skeleton :loading="loading" animated :count="1">
								<template slot="template">
									<el-skeleton-item
										variant="image"
										style="width: 126px;height: 160px;margin: auto;"
									/>
									<el-skeleton-item variant="text" style="margin-top:26px;" />
									<el-skeleton-item variant="text" style="margin-top:16px;height: 160px;width: 100%;" />
								</template>
								<template>
									<img :src="playTeacherPic != ''?playTeacherPic:require('../../../assets/noteacher.png')">
									<div class="teacher_name">{{playTeacher!=""?playTeacher:'主讲教师'}}</div>
									<div class="teacher_des">{{playTeacherContent!=""?playTeacherContent:'暂无介绍信息'}}</div>
								</template>
							</el-skeleton>
						</div>
						<div class="teacher_videolist" v-else>
							<el-skeleton :loading="loading" animated :count="videoList.length">
								<template slot="template">
									<div class="item">
										<div class="itemTitle"><el-skeleton-item variant="text" style='height: 42px;' /></div>
									</div>
								</template>
								<template>
									<div class="item" 
										:class="{selectItem:playId == item.id}" 
										v-for="item in videoList"
										@click="changeData(item.id)">
										<div class="itemTitle">{{item.name}}</div>
									</div>
								</template>
							</el-skeleton>
						</div>
					</div>
				</div>
				<div class="kcList">
					<div class="phtitle">视频简介</div>
					<div class="jianjieCont">
						<el-skeleton :loading="loading" animated :count="3">
							<template slot="template">
								<el-skeleton-item variant="text" style='height: 20px;' /></template>
							<template>{{jkDes}}</template>
						</el-skeleton>
					</div>
					<div class="phtitle">相关推荐</div>
					<div class="lists">
						<div class="tuijianList">
							<div class="swiper-container">
								<div class="swiper-wrapper">
									<el-skeleton :loading="loading" animated :count="4">
										<template slot="template">
											<div class="swiper-slide swiper-item">
												<el-skeleton-item
													variant="image"
													style="width: 285px;height: 168px;margin: auto;"
												/>
											</div>
										</template>
										<template>
											<div class="swiper-slide swiper-item" @click="godetail(item.id)" v-for="item in recommend">
												<img :src="item.sz_img" >
												<div class="title">{{item.title}}</div>
											</div>
										</template>
									</el-skeleton>
								</div>
							</div>
							<div class="swiper-button-prev"></div>
							<div class="swiper-button-next"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { getdata } from '@/axios';
	import Swiper from 'swiper'
	export default{
		data(){
			return{
				oneClass:[],
				loading:true,
				loading1:true,
				selectBar:1,
				videoList:[],
				jkDes:"",
				jkTitle:"",
				playId:0,
				playUrl:"",
				playTeacher:"",
				playTeacherPic:"",
				playTeacherContent:"",
				recommend:[]
			}
		},
		methods:{
			// 资源列表
			datalist(){
				var that = this;
				that.datawrap = [];
				getdata.szjkDetail({
					id:that.$route.query.id
				}).then(res => {
					if(res.code == 200){
						that.videoList = res.data.video;
						that.jkDes = res.data.content;
						that.jkTitle = res.data.title;
						that.playTeacher = res.data.teacher;
						that.playTeacherPic = res.data.photo;
						that.playTeacherContent = res.data.teacher_content
						that.playUrl = res.data.video[0].src;
						that.loading = false;
						if(res.data.recommend.length > 0){
							that.recommend = res.data.recommend;
						}
						that.dataDetail(res.data.video[0].id)
					}
				})
			},
			// 资源详情
			dataDetail(id){
				var that = this;
				that.playId = id;
				for(var i=0;i<that.videoList.length;i++){
					if(id == that.videoList[i].id){
						that.playUrl = that.videoList[i].src;
					}
				}
			},
			// 筛选
			changeData(id){
				var that = this;
				that.dataDetail(id);
			},
			godetail(id){
				var that = this;
				that.$router.push({
					path:'/szjkDetail',
					query:{
						id:id,
						index:that.$route.query.index
					}
				})
			}
		},
		mounted(){
			var that = this;
			that.datalist();
		},
		created() {
			setTimeout(function(){
				var swiper = new Swiper('.tuijianList .swiper-container',{
					slidesPerView : 4,
					slidesPerGroup : 4,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
				})
			},1000)
			this.$emit("highLight",this.$route.query.index,"","","");
		},
		watch: {
			$route(to, from) {
				//监听路由是否变化
				if (to.query.id != from.query.id) {
					//变化后的操作
					// this.count1 = to.query.count;
					this.$router.go(0);
					this.init(); //重新加载数据
				}
			},
		},
	}
</script>

<style lang="scss">
	@import '@/common/index.scss';
	.szzy1{
		width: 100%;
		&_banenr{
			width: 100%;
			height: 540px;
			background: url(../../../assets/kcsz_banner_bg.png) no-repeat;
			background-size: 100% 100%;
		}
		.datalist{
			position: relative;
			width: $indexWidth;
			margin: 0 auto 0 auto;
			.jktitle{
				font-weight: bold;
				padding: 20px 0;
				font-family: $indexFontTitle;
				width: 100%;
				color: $indexColor2;
				font-size: 24px;
				line-height: 35px;
			}
			.top_img{
				width: 918px;
				margin:0 auto 28px auto;
				img{
					width: 100%;
				}
			}
			.content{
				width: 100%;
				&_play{
					width: 100%;
					height: 504px;
					display: flex;
					justify-content: space-between;
					.left_video{
						width: 896px;
						height: 100%;
						background: rgb(39,40,34);
						video{
							width: 100%;
							height: 100%;
							outline: none;
						}
					}
					.teacher{
						width: 284px;
						height: 100%;
						box-sizing: border-box;
						background: $indexColor4;
						box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
						border-radius: 8px;
						padding: 0 26px 26px 26px;
						&_bar{
							font-weight: bold;
							width: 100%;
							height: 50px;
							display: flex;
							justify-content: space-between;
							line-height: 50px;
							margin-bottom: 20px;
							font-size: 16px;
							border-bottom: 1px solid #DDDDDD;
							>span{
								display: block;
								cursor: pointer;
								text-align: center;
								width: 50%;
								font-family: $indexFontSubTitle;
								color: $indexColor;
								border-bottom: 2px solid rgba($color: #000000, $alpha: 0);
							}
							>span:hover{
								color: $indexColor2;
								font-family: $indexFontSubTitle1;
								border-bottom: 2px solid #AC1418;
							}
							.selectBar{
								color: $indexColor2;
								border-bottom: 2px solid #AC1418;
							}
						}
						&_pic{
							width: 100%;
							text-align: center;
							img{
								width: 126px;
								height: 160px;
							}
						}
						&_name{
							margin-top: 26px;
							font-size: 22px;
							text-align: center;
							width: 100%;
							font-weight: bold;
							font-family: $indexFontTitle;
						}
						&_des{
							width: 100%;
							height: 160px;
							color: $indexColor;
							font-size: 14px;
							overflow-y: scroll;
							overflow-x: hidden;
							text-align: center;
							line-height: 20px;
							margin-top: 16px;
						}
						&_des::-webkit-scrollbar{
							width:0px;
							height:12px;
						}
						&_videolist{
							width: 100%;
							height: 410px;
							overflow-y: scroll;
							overflow-x: hidden;
							.item{
								cursor: pointer;
								padding: 14px 0;
								border-bottom: 1px solid #DDDDDD;
								.itemTitle{
									max-height: 42px;
									line-height: 21px;
									color: $indexColor;
									margin-bottom: 16px;
									font-size: 16px;
									overflow: hidden;
								}
								.itemTime{
									color: #939393;
									font-size: 14px;
								}
							}
							.item:hover{
								.itemTitle{
									color: #CB272B;
								}
							}
							.item:nth-child(1){
								margin-top: -10px;
							}
							.selectItem{
								.itemTitle{
									color: #CB272B;
								}
							}
						}
					}
				}
				.kcList{
					width: 100%;
					.phtitle{
						font-family: $indexFontTitle;
						font-weight: bold;
						width: 100%;
						line-height: 80px;
						height: 80px;
						color: $indexColor2;
						font-size: 24px;
					}
					.jianjieCont{
						padding-bottom: 24px;
						color: $indexColor;
						font-size: 16px;
						line-height: 24px;
						border-bottom: 1px solid #DDDDDD;
					}
					.jianjieCont::-webkit-scrollbar{
						width: 0 !important;
					}
					.lists{
						width: 100%;
						.tuijianList{
							position: relative;
							width: 100%;
							height: 168px;
							.swiper-container{
								height: 100%;
								width: 100%;
								.swiper-wrapper>div{
									display: flex;
								}
								.el-skeleton{
									display: flex;
								}
								.swiper-item{
									cursor: pointer;
									overflow: hidden;
									position: relative;
									height: 100%;
									width: 285px !important;
									margin-right: 20px;
									img{
										height: 100%;
										width: 100%;
										object-fit: cover;
										transition: all 0.3s;
									}
									.title{
										position: absolute;
										z-index: 11;
										width: 100%;
										line-height: 44px;
										padding: 0 16px;
										box-sizing: border-box;
										color: #fff;
										font-size: 14px;
										overflow: hidden;
										bottom: 0;
										background: rgba(56, 56, 56, 0.6);
										height: 44px;
									}
								}
								.swiper-item:hover{
									img{
										transform: scale(1.1);
									}
								}
								.swiper-item:nth-child(4n){
									margin-right: 0;
								}
							}
							.swiper-button-prev{
								width: 26px;
								height: 26px;
								left: -50px !important;
								background: url(../../../assets/jkprev.png) no-repeat;
								background-size: 100% 100%;
							}
							.swiper-button-prev::after{
								content: "" !important;
							}
							.swiper-button-next{
								width: 26px;
								height: 26px;
								right: -50px !important;
								background: url(../../../assets/jknex.png) no-repeat;
								background-size: 100% 100%;
							}
							.swiper-button-next::after{
								content: "" !important;
							}
						}
					}
				}
			}
		}
	}
</style>
